const inlineTypes = {
  LINK: 'link',
  MENTION: 'mention',
};

export default inlineTypes;
